import { Link } from "react-router-dom";
import { ArrowRight, PackageCheck } from "lucide-react";
import { FIVE_RANGE } from "@/data/fiveRange";

export function FiveProductArtwork({ product, compact = false }) {
  return (
    <div
      className={"relative overflow-hidden rounded-lg flex flex-col justify-between text-white " + (compact ? "h-52 p-5" : "min-h-[300px] p-8")}
      style={{ background: "linear-gradient(135deg, " + product.colors[0] + ", " + product.colors[1] + ")" }}
      aria-label={product.name + " product title graphic"}
    >
      <div className="absolute -right-14 -bottom-24 h-64 w-64 rounded-full border-[34px] border-white/10 pointer-events-none" />
      <div className="absolute -right-8 top-6 h-32 w-32 rounded-full border-[22px] border-white/10 pointer-events-none" />
      <div className="relative text-sm tracking-[0.23em] uppercase font-semibold text-white/90">Forage</div>
      <div className="relative z-10">
        <div className={"font-display font-black leading-tight break-words " + (compact ? "text-2xl" : "text-4xl")}>{product.shortName}</div>
        <div className="mt-3 text-xs uppercase tracking-widest text-white/80">{product.type}</div>
      </div>
      <div className="relative flex items-center gap-2 text-[11px] uppercase tracking-wider text-white/80">
        <PackageCheck size={16} /> Animal feed supplement
      </div>
    </div>
  );
}

export default function FiveRangeSection({ showAll = true }) {
  const products = showAll ? FIVE_RANGE : FIVE_RANGE.slice(0, 4);

  return (
    <section id="our-key-products" className="section-padding bg-white" data-testid="five-range-section">
      <div className="container-fr">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10">
          <div className="max-w-3xl">
            <span className="overline">Our Key Products</span>
            <h2 className="h-section mt-3">Meet the Five Range.</h2>
            <p className="text-slate-600 mt-4 leading-relaxed">
              A selection of Forage animal nutrition and feed supplements. Explore formulations,
              key benefits and available pack sizes for each product.
            </p>
          </div>
          {!showAll && (
            <Link to="/products#our-key-products" className="text-[#2A9D8F] font-semibold inline-flex items-center gap-2">
              Explore all eight <ArrowRight size={16} />
            </Link>
          )}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {products.map((product) => (
            <Link
              key={product.slug}
              to={"/five-range/" + product.slug}
              className="group rounded-xl overflow-hidden border border-slate-200 bg-[#F8FAFC] hover:shadow-xl transition-all hover:-translate-y-1"
              data-testid={"five-product-" + product.slug}
            >
              <div className="p-3 pb-0">
                <FiveProductArtwork product={product} compact />
              </div>
              <div className="p-5">
                <p className="text-[11px] uppercase tracking-wider text-[#2A9D8F] font-bold">{product.type}</p>
                <h3 className="text-lg font-display font-bold text-[#0B2545] mt-2">{product.name}</h3>
                <p className="text-sm text-slate-600 mt-2 line-clamp-2">{product.description}</p>
                <div className="flex justify-between gap-2 items-center text-[#2A9D8F] text-sm font-semibold mt-5">
                  View details <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
